exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".auto-complete {\n  position: relative;\n  padding: 0;\n}", ""]);

// exports
